import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Footer from '../../layout/footer/footer';
import '../../styles/post.css';
import { createComment, getComments, showPost } from '../../services/postService';
import { imgBaseUrl, videoBaseUrl } from '../../utils/api';

const buildImageUrl = (imageName) => {
  if (!imageName) return null;
  if (/^https?:/i.test(imageName)) return imageName;
  const base = (imgBaseUrl || '').replace(/\/$/, '');
  const normalized = String(imageName).replace(/^\//, '');
  return base ? `${base}/${normalized}` : normalized;
};
const buildVideoUrl = (video) => {
  if (!video) return null;
  if (/^https?:/i.test(video)) return video;
  const base = (videoBaseUrl || '').replace(/\/$/, '');
  const normalized = String(video).replace(/^\//, '');
  console.log('aaaaa')
  console.log(base)
  return base ? `${base}/${normalized}` : normalized;
};

const formatCommentDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('fa-IR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const splitTags = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  // جداکننده‌ها: ویرگول انگلیسی/فارسی، نقطه‌ویرگول، هشتگ، پایپ
  return String(value)
    .split(/[,،;#|]+/)
    .map((tag) => tag.trim())
    .filter(Boolean);
};

const PostStatus = ({ message }) => (
  <div className="postpp-empty" role="status">
    {message}
  </div>
);

const PostPage = () => {
  const { postId = '' } = useParams();
  const numericId = useMemo(() => {
    const candidate = Number(postId);
    return Number.isFinite(candidate) && candidate > 0 ? candidate : null;
  }, [postId]);

  const [state, setState] = useState({ post: null, loading: true, error: '' });
  const [shareHint, setShareHint] = useState('');

  const [commentsState, setCommentsState] = useState({ items: [], loading: true, error: '' });
  const [formState, setFormState] = useState({ fullName: '', email: '', comment: '' });
  const [formStatus, setFormStatus] = useState({ success: '', error: '' });
  const [submitting, setSubmitting] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  // بررسی نوع فایل ویدیو
  const getVideoType = (url) => {
    if (url.endsWith('.mp4')) return 'video/mp4';
    if (url.endsWith('.webm')) return 'video/webm';
    if (url.endsWith('.ogg')) return 'video/ogg';
    if (url.endsWith('.mov')) return 'video/quicktime';
    return 'video/mp4';
  };
  
  const loadComments = useCallback(async () => {
    if (!numericId) {
      setCommentsState({ items: [], loading: false, error: 'شناسه خبر معتبر نیست.' });
      return;
    }
    setCommentsState((prev) => ({ ...prev, loading: true, error: '' }));
    try {
      const response = await getComments({ id: numericId, start: 1, length: 50 });
      console.log(response)
      const list = response?.data?.comments ?? [];
      setCommentsState({ items: list, loading: false, error: '' });
    } catch (err) {
      console.error('Failed to load comments', err);
      setCommentsState({ items: [], loading: false, error: 'بارگذاری دیدگاه‌ها با مشکل مواجه شد.' });
    }
  }, [numericId]);

  // بارگذاری پست — فقط وقتی numericId تغییر می‌کند
  useEffect(() => {
    let cancelled = false;

    if (!numericId) {
      setState({ post: null, loading: false, error: 'شناسه خبر معتبر نیست.' });
      return () => {
        cancelled = true;
      };
    }

    setState({ post: null, loading: true, error: '' });

    (async () => {
      try {
        const post = await showPost({ id: numericId });
        if (cancelled) return;
        setState({ post, loading: false, error: '' });
      } catch (err) {
        if (cancelled) return;
        console.error('Failed to load post', err);
        setState({ post: null, loading: false, error: 'بارگذاری خبر با مشکل مواجه شد.' });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [numericId]);

  // بارگذاری دیدگاه‌ها وقتی شناسه معتبر است (یا هر بار که numericId عوض شد)
  useEffect(() => {
    if (numericId) {
      loadComments();
    } else {
      setCommentsState({ items: [], loading: false, error: '' });
    }
  }, [numericId, loadComments]);

  const handleFormFieldChange = (field) => (event) => {
    const { value } = event.target;
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleCommentSubmit = async (event) => {
    event.preventDefault();
    if (!numericId) {
      setFormStatus({ success: '', error: 'شناسه خبر معتبر نیست.' });
      return;
    }
    const trimmedComment = formState.comment.trim();
    if (!trimmedComment) {
      setFormStatus({ success: '', error: 'متن دیدگاه را بنویسید.' });
      return;
    }
    setSubmitting(true);
    setFormStatus({ success: '', error: '' });
    try {
      await createComment({
        pageId: numericId,
        comment: trimmedComment,
        fullName: formState.fullName.trim() || undefined,
        email: formState.email.trim() || undefined,
      });
      setFormStatus({ success: 'دیدگاه شما با موفقیت ثبت شد و پس از تأیید نمایش داده می‌شود.', error: '' });
      setFormState((prev) => ({ ...prev, comment: '' }));
      await loadComments();
    } catch (error) {
      console.error('Failed to submit comment', error);
      setFormStatus({ success: '', error: 'ارسال دیدگاه با مشکل مواجه شد.' });
    } finally {
      setSubmitting(false);
    }
  };

  const normalizePostHtml = (html) => {
  if (!html || typeof html !== 'string') {
    return '<p>متن خبری برای نمایش ثبت نشده است.</p>';
  }

  return html.replace(
    /font-family\s*:\s*[^;"']+;?/gi,
    '',
  );
};
  const hasVideoTag = (html) => {
    if (!html || typeof html !== 'string') return false;

    return /<video\b[^>]*>/i.test(html);
  };
  const handleShare = async () => {
    const url = typeof window !== 'undefined' ? window.location.href : '';
    const title = state.post?.title || 'خبر';

    try {
      if (navigator?.share) {
        await navigator.share({ title, url });
        return;
      }
      if (navigator?.clipboard && url) {
        await navigator.clipboard.writeText(url);
        setShareHint('لینک خبر کپی شد.');
        setTimeout(() => setShareHint(''), 2500);
      }
    } catch (err) {
      console.error('Share failed', err);
      setShareHint('امکان اشتراک‌گذاری فراهم نشد.');
      setTimeout(() => setShareHint(''), 2500);
    }
  };

  if (state.loading) {
    return (
      <>
        <div className="postpp-status">در حال بارگذاری خبر...</div>
        <Footer />
      </>
    );
  }

  if (state.error) {
    return (
      <>
        <PostStatus message={state.error} />
        <Footer />
      </>
    );
  }

  if (!state.post) {
    return (
      <>
        <PostStatus message="خبر مورد نظر پیدا نشد." />
        <Footer />
      </>
    );
  }
  const post = state.post;
  const hasVideoInText = hasVideoTag(post.text);
  const categories = Array.isArray(post.categoryList) ? post.categoryList : [];
  const primaryCategory = categories[0];
  const tags = splitTags(post.tagsList);
  const imageUrl = buildImageUrl(post.imageName || post.smallImageName);
  const metaItems = [
    post.shamsiCreateDate ? `منتشر شده در ${post.shamsiCreateDate}` : null,
    typeof post.visitCount === 'number' ? `بازدید ${post.visitCount}` : null,
    typeof post.commentCount === 'number' ? `نظرات ${post.commentCount}` : null,
  ].filter(Boolean);
  const writer = post.writer?.trim() || 'خبرنگار نامشخص';
  const writerInitial = writer.charAt(0) || 'ن';
  const lead = post.headline?.trim() || post.shortDescription?.trim() || '';
  const breadcrumbTitle = post.title || 'خبر';
  const shareFeedback = shareHint;

  return (
    <>
      <div className="postpp-page" dir="rtl">
        <header className="postpp-head">
           <nav className="postpp-left" aria-label="مسیر راهنما">
            <Link to="/">خانه</Link>
            {primaryCategory && (
              <>
                <span className="categorypp-sep">/</span>
                <Link to={`/news/${primaryCategory.id}`}>{primaryCategory.title}</Link>
              </>
            )}
            <span className="categorypp-sep">/</span>
            <span>{breadcrumbTitle}</span>
          </nav>
              <div className="postpp-left">
             
              {shareFeedback && <span className="postpp-meta">{shareFeedback}</span>}
              <span className="postpp-divider" aria-hidden="true" />
              {metaItems.map((meta, index) => (
                <React.Fragment key={`meta-${index}`}>
                  {index !== 0 && <span className="postpp-dot" aria-hidden="true" />}
                  <span className="postpp-meta">{meta}</span>
                </React.Fragment>
              ))}
            </div>
        </header>
        <header className="postpp-head" style={{"background": "transparent","padding": "0","margin": "0 auto"}}>
         

          <div className="postpp-bar">
            <h1 className="postpp-title">
              <span>{breadcrumbTitle}</span>
            </h1>
          </div>
        </header>

        <div className="postpp-container">
       
          <main>
            {/* <figure className="postpp-hero">
              {imageUrl ? (
                <img src={imageUrl} alt={post.title || 'تصویر خبر'} loading="lazy" />
              ) : (
                <div className="postpp-hero-placeholder" aria-hidden="true" />
              )}
            </figure> */}

            {/* <div className="postpp-under-hero">
              <h2 className="postpp-title-inline">{post.title}</h2>
              <div className="postpp-inline-meta">
                {metaItems.map((meta, index) => (
                  <span className="postpp-meta" key={`inline-meta-${index}`}>
                    {meta}
                  </span>
                ))}
                <span className="postpp-meta">
                  <span className="postpp-avatar" aria-hidden="true">{writerInitial}</span>
                  <span>{writer}</span>
                </span>
              </div>
            </div>

            {lead && <p className="postpp-lead">{lead}</p>} */}
          
          <div class="news-content">
            {!hasVideoInText  && (
              <img src={imageUrl} alt={post.title || 'تصویر خبر'} loading="lazy" className='news-image' />
            )}

            {/* نمایش ویدیو اگر وجود داشته باشد */}
            {post.videoUrl && (
              <div className="news-image video-news">
                <video 
                  controls
                  width="100%"
                  height="auto"
                  poster={post.imageUrl} // استفاده از تصویر خبر به عنوان پوستر
                  onPlay={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                >
                  <source src={buildVideoUrl(post.videoUrl)} type={getVideoType(post.videoUrl)} />
                  مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
                </video>
                
              </div>
            )}
            <article
                className="news-text"
                dir="rtl"
                dangerouslySetInnerHTML={{
                  __html: normalizePostHtml(post.text),
                }}
              />
             {/* <article
              className="news-text"
              dir="rtl"
              dangerouslySetInnerHTML={{
                __html: post.text || '<p>متن خبری برای نمایش ثبت نشده است.</p>',
              }}
            /> */}
        </div>
            {/* <article
              className="postpp-content"
              dir="rtl"
              dangerouslySetInnerHTML={{
                __html: post.text || '<p>متن خبری برای نمایش ثبت نشده است.</p>',
              }}
            /> */}

            <div className="postpp-row" style={{ marginTop: '18px' }}>
              {/* <div>
                <span className="postpp-chip">شناسه خبر: {post.pageId}</span>
              </div> */}
              {categories.length > 0 && (
                <div className="postpp-chips">
                  {categories.map((category) => (
                    <span className="postpp-chip" key={`chip-cat-${category.id || category.title}`}>
                      <Link to={`/news/${category.id}`}>#{category.title}</Link>
                    </span>
                  ))}
                </div>
              )}
            </div>

            {tags.length > 0 && (
              <div className="postpp-row" style={{ marginTop: '12px' }}>
                <div className="postpp-chips">
                  {tags.map((tag) => (
                    <span className="postpp-chip" key={`tag-${tag}`}>#{tag}</span>
                  ))}
                </div>
              </div>
            )}
          </main>
        </div>

        <section className="postpp-comments-wrap" aria-label="دیدگاه کاربران">
          <div className="postpp-sec-title">
            <span className="postpp-sec-pill">دیدگاه‌های تأیید شده</span>
            <hr className="postpp-dashline" />
          </div>
          {commentsState.loading ? (
            <p className="postpp-status">در حال بارگذاری دیدگاه‌ها...</p>
          ) : commentsState.error ? (
            <p className="postpp-status">{commentsState.error}</p>
          ) : !commentsState.items.length ? (
            <p className="postpp-status">نظری ثبت نشده است.</p>
          ) : (
            commentsState.items.map((comment) => {
              const commentDate = formatCommentDate(comment.createDate);
              const commenterName = comment.fullName || 'کاربر';
              return (
                <>
                <article className="postpp-review" key={comment.id || comment.pageCommentId}>
                  <div className="postpp-review-avatar">
                    <img
                      src="/landing/uploads/mimt/assets/images/profile.png"
                      alt={commenterName}
                    />
                  </div>
                  <div>
                    <div className="postpp-review-header">
                      {commentDate ? (
                        <time dateTime={comment.createDate || ''}>{comment.createDate}</time>
                      ) : null}
                      <span className="postpp-review-name">{commenterName}</span>
                    </div>
                    <div className="postpp-review-body">
                      {comment.comment || ''}
                    </div>
                  </div>
                </article>
                <hr className="postpp-dashline" />
              </>
              );
            })
          )}
        </section>

        <section className="postpp-comments-wrap" aria-label="ارسال دیدگاه">
          <div className="postpp-sec-title">
            <span className="postpp-sec-pill">دیدگاه خود را بنویسید</span>
            <hr className="postpp-dashline" />
          </div>

          <form className="postpp-comment-form" onSubmit={handleCommentSubmit} dir="rtl">
            <div className="postpp-form-top">
              <label className="postpp-chip-input">
                <span aria-hidden="true">✉</span>
                <input
                  type="email"
                  value={formState.email}
                  onChange={handleFormFieldChange('email')}
                  placeholder="ایمیل *"
                />
              </label>
              <label className="postpp-chip-input">
                <span aria-hidden="true">👤</span>
                <input
                  type="text"
                  value={formState.fullName}
                  onChange={handleFormFieldChange('fullName')}
                  placeholder="نام *"
                />
              </label>
            </div>

            <textarea
              className="postpp-textarea"
              placeholder="متن دیدگاه"
              value={formState.comment}
              onChange={handleFormFieldChange('comment')}
            />

            <div className="postpp-send" style={{ marginTop: '12px' }}>
              <button className="btn postpp-btn" type="submit" disabled={submitting}>ارسال</button>
            </div>
            {formStatus.error && <p className="postpp-status">{formStatus.error}</p>}
            {formStatus.success && <p className="postpp-status">{formStatus.success}</p>}
          </form>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default PostPage;
